<ng-container *ngIf="status">
    <div *ngIf="dotStatus(status) === 'delivered'">
        <div class="delivered-status">
            {{'DELIVERED' | translate}}
        </div>
    </div>
    <div *ngIf="dotStatus(status) === 'withdrawn'">
        <div class="withdrawn-status">
            {{'WITHDRAWN' | translate}}
        </div>
    </div>
    <div *ngIf="dotStatus(status) === 'rejected'">
        <div class="withdrawn-status">
            {{'REJECTED' | translate}}
        </div>
    </div>
    <div *ngIf="dotStatus(status) === 'timeout'">
        <div class="timeout-status">
            {{'TIMEOUT' | translate}}
        </div>
    </div>
    <div class="d-flex" *ngIf="dotStatus(status) === 'other'">
        <ng-container *ngFor="let item of status; let i=index">
            <!-- Step -->
            <div class="status status-empty justify-content-center d-flex align-items-center" *ngIf="item.status === ''" placement="top" [ngbTooltip]="item.description"></div>
            <div class="status status-error justify-content-center d-flex align-items-center" *ngIf="item?.status === 'error'" placement="top" [ngbTooltip]="item.description">
                <fa-icon [icon]="faXmark"></fa-icon>
            </div>
            <div class="status status-pending justify-content-center d-flex align-items-center" *ngIf="item?.status === 'pending'" placement="top" [ngbTooltip]="item.description">
                <fa-icon [icon]="faArrowRight"></fa-icon>
            </div>
            <div class="status status-success justify-content-center d-flex align-items-center" *ngIf="item?.status === 'success'" placement="top" [ngbTooltip]="item.description">
                <fa-icon [icon]="faCheck"></fa-icon>
            </div>

            <!-- Divisore -->
            <div class="status-connector" *ngIf="i != status.length-1"></div>
        </ng-container>
    </div>
</ng-container>